import { SvgIcon } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ListItemButton } from 'components/List'
import DuplicateIcon from 'images/icons/duplicate.svg?react'
import { useDuplicateTest } from './hooks/useDuplicateTest'

import type { DuplicateTestItemProps } from './types'

export const DuplicateTestItem = ({ id }: DuplicateTestItemProps): React.JSX.Element => {
  const { t } = useTranslation('features/abTests')
  const { duplicateAbTest } = useDuplicateTest()

  return (
    <ListItemButton
      data-cy='actions-duplicate-test'
      icon={
        <SvgIcon
          component={DuplicateIcon}
          data-cy='duplicate-test-icon'
          inheritViewBox
        />
      }
      onClick={(): void => duplicateAbTest(id)}
      text={t('list.actions.duplicate.label')}
    />
  )
}
